import {Link} from "react-router-dom";

function P5(){
    return(
        <main className="main">
            <h2>Перелік трудових функцій, професійних компетентностей (за трудовою дією або групою трудових дій, що входять до них), умовні позначення трудових функцій </h2>
            <table>
                <tr className='bold'>
                    <td>
                        Умовні позначення
                    </td>
                    <td>
                        Трудові функції
                    </td>
                    <td>
                        Професійні компетентності (за трудовою дією або групою трудових дій)
                    </td>
                    <td>
                        Умовні позначення
                    </td>
                </tr>
                <tr className='bold'>
                    <td rowSpan="7">
                        А
                    </td>
                    <td rowSpan="7">
                        Організація здорового, безпечного, розвивального, інклюзивного освітнього середовища
                    </td>
                    <td>
                       <Link to='/a1'>Здоров’язбережувальна</Link>
                </td>
                    <td>
                        А1
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність забезпечити дотримання правил пожежної безпеки, цивільного захисту та безпеки життєдіяльності, вимог санітарного законодавства, законодавства про безпечність та якість харчових продуктів під час освітнього процесу
                    </td>
                    <td>
                        А1.1
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність створювати освітнє середовище, вільне від насильства та булінгу
                    </td>
                    <td>
                        А1.2
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до організації діяльності психологічної служби та соціально-педагогічного патронажу в закладі дошкільної освіти
                    </td>
                    <td>
                        А1.3
                    </td>
                </tr>
                <tr>
                    <td className='bold'>
                       <Link to='/a2'>Проектувальна</Link>
                </td>
                    <td className='bold'>
                        А2
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до проектування та аналізу ефективності організації освітнього простору
                    </td>
                    <td>
                        А2.1
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до створення безпечних і нешкідливих умов праці
                    </td>
                    <td>
                        А2.2
                    </td>
                </tr>
                <tr className='bold'>
                    <td rowSpan="11">
                        Б
                    </td>
                    <td rowSpan="11">
                        Управління закладом дошкільної освіти
                    </td>
                    <td>
                       <Link to='/b1'> Операційне управління закладом дошкільної освіти</Link>
                    </td>
                    <td>
                        Б1
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність ефективно здійснювати фінансово-господарську діяльність закладу дошкільної освіти
                    </td>
                    <td>
                        Б1.1
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до організації та контролю харчування у закладі дошкільної освіти
                    </td>
                    <td>
                        Б1.2
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до організації та контролю медичного обслуговування у закладі дошкільної освіти
                    </td>
                    <td>
                        Б1.3
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до управління персоналом та командної взаємодії
                    </td>
                    <td>
                        Б1.4
                    </td>
                </tr>
                <tr className='bold'>
                    <td>
                        <Link to='/b2'>Організаційно-методична</Link>
                    </td>
                    <td>
                        Б2
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність забезпечувати організацію освітнього процесу у закладі дошкільної освіти з урахуванням запитів його учасників
                    </td>
                    <td>
                        Б2.1
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність створювати умови для ефективного функціонування команди психолого-педагогічного супроводу
                    </td>
                    <td>
                        Б2.2
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до методичної підтримки та супроводу педагогічного персоналу закладу дошкільної освіти
                    </td>
                    <td>
                        Б2.3
                    </td>
                </tr>
                <tr className='bold'>
                    <td>
                       <Link to='/b3'> Комунікативна</Link>
                    </td>
                    <td>
                        БЗ
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до ефективної комунікації з учасниками освітнього процесу та органами влади, іншими організаціями, представниками громади
                    </td>
                    <td>
                        Б3.1
                    </td>
                </tr>
                <tr className='bold'>
                    <td rowSpan="7">
                        В
                    </td>
                    <td rowSpan="7">
                        Безперервний особистісний та професійний розвиток
                    </td>
                    <td>
                     <Link to='/v1'>   Здатність до навчання впродовж життя</Link>
                    </td>
                    <td>
                        В1
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до саморефлексії та самооцінювання управлінської діяльності
                    </td>
                    <td>
                        В1.1

                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність планувати та реалізовувати індивідуальний професійний розвиток та самоосвіту
                    </td>
                    <td>
                        В1.2
                    </td>
                </tr>
                <tr className='bold'>
                    <td>
                      <Link to='/v2'> Інформаційно-комунікаційна</Link>
                </td>
                    <td>
                        В2
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність орієнтуватись в інформаційному просторі
                    </td>
                    <td>
                        В2.1
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність ефективно використовувати ІКТ та електронні (цифрові) освітні ресурси
                    </td>
                    <td>
                        В2.2
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність дотримуватись правил безпечної поведінки в цифровому середовищі
                    </td>
                    <td>
                        В2.3
                    </td>
                </tr>
                <tr className='bold'>
                    <td rowSpan="7">
                        Г
                    </td>
                    <td rowSpan="7">
                        Лідерство і партнерська взаємодія
                    </td>
                    <td>
                       <Link to='/h1'> Лідерська</Link>
                    </td>
                    <td>
                        Г1
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до самопрезентації та презентації діяльності закладу дошкільної освіти
                    </td>
                    <td>
                        Г1.1
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до адаптивності та стресостійкості, швидкого реагування на зміни під час професійної діяльності
                    </td>
                    <td>
                        Г1.2
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до ефективного врегулювання конфліктів та профілактики професійного вигорання
                    </td>
                    <td>
                        Г1.3
                    </td>
                </tr>
                <tr className='bold'>
                    <td>
                       <Link to='/h2'> Емоційно-етична</Link>
                    </td>
                    <td>
                        Г2
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до саморегуляції та толерантної взаємодії
                    </td>
                    <td>
                        Г2.1
                    </td>
                </tr>
                <tr>
                    <td>
                        Здатність до усвідомленої, конструктивної та екологічної взаємодії з учасниками освітнього процесу
                    </td>
                    <td>
                        Г2.2
                    </td>
                </tr>

                <tr className='bold'>
                    <td rowspan="13">
                        Ґ
                    </td>
                    <td rowspan="13">
                        Стратегічний розвиток закладу дошкільної освіти
                    </td>

                    <td>
                       <Link to='/g1'> Стратегічне управління та розвиток закладу дошкільної освіти</Link>
                    </td>
                    <td>
                        Ґ1
                    </td>
                </tr>
                <tr>
                    <td>Здатність до використання інструментів стратегічного планування діяльності закладу дошкільної освіти</td>
                    <td> Ґ1.1</td>
                </tr>
                <tr>
                    <td> Здатність розробляти стратегію закладу освіти з урахуванням інтересів та потреб учасників освітнього процесу </td>
                    <td>Ґ1.2</td>
                </tr>
                <tr>
                    <td> Здатність забезпечити функціонування внутрішньої системи забезпечення якості освіти</td>
                    <td>Ґ1.3</td>
                </tr>
                <tr>
                    <td> Здатність створювати умови для здійснення дієвого та відкритого громадського нагляду (контролю) за діяльністю закладу дошкільної освіти</td>
                    <td> Ґ1.4</td>
                </tr>
                <tr>
                    <td> Здатність створювати умови для громадського самоврядування в закладі дошкільної освіти</td>
                    <td>Ґ1.5</td>
                </tr>
                <tr className='bold'>
                    <td>
                        <Link to='/g2'>Стратегічна комунікація</Link>
                    </td>
                    <td>Ґ2</td>
                </tr>
                <tr>
                    <td> Здатність представляти інтереси закладу дошкільної освіти у відносинах з державними органами, органами місцевого самоврядування, юридичними та фізичними особами </td>
                    <td>Ґ2.1</td>
                </tr>
                <tr className='bold'>
                    <td>
                        <Link to='/g3'>Нормативно-правова</Link>
                    </td>
                    <td>ҐЗ</td>
                </tr>
                <tr>
                    <td>Здатність керуватися в управлінській діяльності законодавством України</td>
                    <td>Ґ3.1</td>
                </tr>
                <tr>
                    <td>Здатність до документування управлінської діяльності</td>
                    <td>Ґ3.2</td>
                </tr>
                <tr>
                    <td>Здатність забезпечувати дотримання академічної доброчесності учасниками освітнього процесу</td>
                    <td>ҐЗ.З</td>
                </tr>
                <tr>
                    <td>Здатність здійснювати професійну діяльність державною мовою</td>
                    <td>Ґ3.4</td>
                </tr>
            </table>
        </main>
    )
}

export {P5}